<app-area-utente ></app-area-utente>

<app-header></app-header>

<main>
    <router-outlet></router-outlet>
</main>

<aria-loader></aria-loader>
<aria-notification></aria-notification>

<app-footer></app-footer>